import { createContext, useContext } from "react";
import { useDocumentData } from "react-firebase-hooks/firestore";
import { doc, collection, setDoc } from "firebase/firestore";
import { useSessionContext } from "hooks/useSession";
import { useFirebaseRef as useSessionFirebaseRef } from "hooks/useSession";

export const useFirebaseRef = () => {
  const { session } = useSessionContext();
  const sessionId = session?.id || "SESSIONNOTFOUND";
  const sessionRef = useSessionFirebaseRef(sessionId);
  
  if (!sessionRef) return null;
  
  // Create a reference to the calculator document in the activities subcollection
  return doc(collection(sessionRef, "activities"), "calculator");
};

export const useCalculatorActivity = () => {
  const ref = useFirebaseRef();

  let [calcAct, loading, error] = useDocumentData(ref);

  const instructions = calcAct?.instructions || `Try to make the number 5!`;
  const bannedButtonIds = calcAct?.bannedButtonIds || [7, 5, 4, 3, 2, "*", "/"];
  const goal = calcAct?.goal || 5;
  const startFormula = calcAct?.startFormula || "";
  const presentingUserId = calcAct?.presentingUserId || false;

  const update = (data) => {
    if (!ref) return Promise.reject(new Error("No reference available"));
    return setDoc(ref, data, { merge: true });
  };

  const togglePresentingUser = (userId) => {
    if (calcAct?.presentingUserId === userId)
      return update({ presentingUserId: null });

    update({ presentingUserId: userId });
  };

  const setPresentingUser = (userId) => {
    update({ presentingUserId: userId });
  };

  return {
    bannedButtonIds,
    goal,
    instructions,
    startFormula,
    loading,
    error,
    update,
    togglePresentingUser,
    setPresentingUser,
    presentingUserId,
  };
};

const Context = createContext();

export const CalculatorActivityProvider = ({ children }) => {
  const value = useCalculatorActivity();
  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const useCalculatorActivityContext = () => {
  return useContext(Context);
};
